import { Navigate, Outlet } from "react-router-dom";
import { Icon } from "@project/ui";
import { DEFAULT_LOCALE, getTranslation } from "@project/i18n";
import { authClient } from "@apps/dashboard/lib/auth-client";
import { hasValidAuthSession } from "@apps/dashboard/lib/auth-session";

const loadingLabel = getTranslation(DEFAULT_LOCALE).common.loading;

/** Rutas de login/registro: si ya hay sesión, vuelve al panel. */
export function GuestOnlyRoute(): JSX.Element {
  const { data, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surface text-on-surface">
        <Icon name="LoaderCircle" className="size-10 animate-spin text-primary" strokeWidth={1.5} aria-hidden />
        <p className="text-body-md text-on-surface-variant">{loadingLabel}</p>
      </div>
    );
  }

  if (hasValidAuthSession(data)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
